import * as React from 'react';

/**
 *
 * IspResultsContainer component
 * @extends {React.PureComponent<IIspSerpProps<IIspSerpData>>}
 */
class IspResultsContainer extends React.Component {

    public render(): JSX.Element | null {
        return (
            <>
                <ul id='isp_search_results_container'>
                    <li className='isp_grid_product isp_grid_product_skeleton'/>
                    <li className='isp_grid_product isp_grid_product_skeleton'/>
                    <li className='isp_grid_product isp_grid_product_skeleton'/>
                    <li className='isp_grid_product isp_grid_product_skeleton'/>
                    <li className='isp_grid_product isp_grid_product_skeleton'/>
                    <li className='isp_grid_product isp_grid_product_skeleton'/>
                    <li className='isp_grid_product isp_grid_product_skeleton'/>
                    <li className='isp_grid_product isp_grid_product_skeleton'/>
                    <li className='isp_grid_product isp_grid_product_skeleton'/>
                    <li className='isp_grid_product isp_grid_product_skeleton'/>
                    <li className='isp_grid_product isp_grid_product_skeleton'/>
                    <li className='isp_grid_product isp_grid_product_skeleton'/>
                </ul>
            </>
        );
    }
}
export default IspResultsContainer;